module.exports = __webpack_public_path__ + "static/media/01_python_core_tojgli_kigyo_szoveggel.b0235649.webp";